// import ReactDOM from "react-dom/client";
import ReactDOM from "react-dom";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'antd/dist/reset.css'
// import './components/cram_school/css/TableTitle.css'
// import './styles/globals.css'
import Demosite from './websites/Demosite';
// import App from 'ot'
axios.defaults.baseURL = "";
// axios.defaults.baseURL = "http://172.0.5.46:8082";
// axios.defaults.baseURL = "https://api-sungolds.orange-technic.com";
// axios.defaults.baseURL = "https://api-pccu.orange-technic.com";
// axios.defaults.baseURL = "https://api-chci.orange-technic.com:8106";
// axios.defaults.baseURL = "https://api-usr-market.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-keytravel.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-commercial.orange-technic.com";
// axios.defaults.baseURL = "http://140.127.56.21:8082";
// axios.defaults.baseURL = "http://192.168.11.125:8082";
// axios.defaults.baseURL = "http://10.0.1.174:8082";
// axios.defaults.baseURL = "http://localhost:8082";
// axios.defaults.baseURL = "https://api-education.orange-technic.com";
// axios.defaults.baseURL = "https://www.orange-technic.com:5021";
// axios.defaults.baseURL = "https://www.orange-technic.com:7443";
// axios.defaults.baseURL = "https://www.orange-technic.com:7469";
// axios.defaults.baseURL = "https://www.orange-technic.com:7497";
// axios.defaults.baseURL = "https://www.orange-technic.com:7492";
// axios.defaults.baseURL = "https://www.orange-technic.com:7483";
// axios.defaults.baseURL = "https://www.orange-technic.com:7501";
// axios.defaults.baseURL = "https://www.orange-technic.com:7505";
// axios.defaults.baseURL = "https://www.orange-technic.com:7517";
// axios.defaults.baseURL = "https://www.orange-technic.com:7522";
// axios.defaults.baseURL = "https://www.orange-technic.com:7526";
// axios.defaults.baseURL = "https://api-preschool-admin.orange-technic.com";
// axios.defaults.baseURL = "https://preschool-admin.orange-technic.com:6454";
// axios.defaults.baseURL = "https://demosite-preschool-admin.orange-technic.com:6454";
// axios.defaults.baseURL = "https://yuankuan.orange-technic.com:8101";
// axios.defaults.baseURL = "https://api-hecheng.orange-technic.com";
// axios.defaults.baseURL = "https://api-learningmath.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-chung-hwa.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-pilot.orange-technic.com";
// axios.defaults.baseURL = "https://libappapi.pccu.edu.tw";
axios.defaults.baseURL = "https://api-iteach.nknu.edu.tw";


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <div>
//         <App />
//     </div>
// );
ReactDOM.render(
    <div>
        <Demosite />
    </div>,
    document.getElementById('root')
);